/* eslint-disable prefer-const */
import leftMenu from '@/views/Menus.vue'
import { mainLayout } from 'amazonia-framework-frontend'
import index from '@/views/DadosPrincipal.vue'

/* let dadosPrincipal = {
  path: '/dados/principal',
  name: 'DadosPrincipal',
  component: () => import('@/views/proposta/DadosPrincipal.vue')
} */

let dadosBeneficiario = {
  path: '/dados/beneficiario',
  name: 'DadosBeneficiario',
  component: () => import('@/views/proposta'),
  props: true
}

let statusSucesso = {
  path: '/status/sucesso',
  name: 'TelaSucesso',
  component: () => import('@/views/TelaSucesso.vue'),
  props: true
}

const routes = [
  {
    path: '',
    components: {
      default: mainLayout,
      leftDrawer: leftMenu
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: index
      },
      dadosBeneficiario,
      statusSucesso
    ]
  }
]

export default routes
